import { useQuery } from "@tanstack/react-query";
import { userProfileService } from "@/services/userProfileService";

export const SOURCE_OF_TRUTH_QUERY_KEY = ["user-profile", "source-of-truth"] as const;

export function useSourceOfTruth() {
  const { data, isLoading, refetch } = useQuery({
    queryKey: SOURCE_OF_TRUTH_QUERY_KEY,
    queryFn: async () => {
      const [docIds, enabled] = await Promise.all([
        userProfileService.getSourceOfTruthDocIds(),
        userProfileService.isSourceOfTruthEnabled(),
      ]);
      return { docIds, enabled };
    },
    staleTime: 60_000,
  });

  return {
    docIds: data?.docIds ?? [],
    profileEnabled: data?.enabled ?? false,
    isLoading,
    refetch,
    hasCanon: (data?.docIds?.length ?? 0) > 0,
  };
}
